import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { UiSwitchModule } from 'angular2-ui-switch';
import { InstallSharedModule } from '../shared/install_shared.module';
import { MapSetupComponent } from './setup/form/map_setup.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MapPreviewComponent } from './setup/preview/map_preview.component';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MapService } from '../shared/services/map.service';

@NgModule({
  imports: [
    CommonModule,
    UiSwitchModule,
    InstallSharedModule,
    PopoverModule.forRoot(),
    FormsModule
  ],
  declarations: [
    MapSetupComponent,
    MapPreviewComponent
  ],
  providers: [
    TranslateService,
    MapService
  ]
})
export class MapModule {}
